import * as React from 'react';

import { FiltersTabsContainer } from '../../containers/FiltersTabsContainer';
import { FiltersContainer } from '../../containers/FiltersContainer';
import * as styles from './Hero.css';
import { mergeStyles } from '@cian/utils';
import { DobroshriftTitle } from './DobroshriftTitle';

export interface IHeroProps {
  title: string;
  isDobroshriftEnabled: boolean;
}

export function Hero({ title, isDobroshriftEnabled }: IHeroProps) {
  return (
    <div className={styles['wrapper']}>
      <div className={styles['container']} data-mark="Hero">
        {isDobroshriftEnabled && (
          <div className={styles['dobroshrift']}>
            <DobroshriftTitle />
            <div className={styles['dobrostrift-caption']}>
              <a
                className={styles['dobroshrift-link']}
                href="https://dobroshrift.ru/"
                rel="noopener noreferrer"
                target="_blank"
              >
                #доброшрифт
              </a>
            </div>
          </div>
        )}
        <div {...mergeStyles(styles['title'], isDobroshriftEnabled && styles['title-transparent'])}>{title}</div>
        <FiltersTabsContainer />
        <FiltersContainer />
      </div>
    </div>
  );
}
